import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageQuery } from '@shared/queries';
import { CrudService } from '@shared/services';
import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { Page, Sort, Language, ParseObject } from '@shared/data';
import { LoadingService } from '@shared/modules/loading';

import { PageListDataTableOptions } from './page-list.data-table-option';

@Component({
  moduleId: 'module.id',
  selector: 'page-list',
  styles: [require('./page-list.component.scss')],
  template: require('./page-list.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class PageListComponent implements OnInit {
  public pages: Page[];
  public searchText: string;
  public language: string;
  public error: Parse.Error;
  public options: PageListDataTableOptions;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private crudService: CrudService) {

    this.options = new PageListDataTableOptions();
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.searchText = params['search'] || '';
      this.fetchPages();
    });
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSearchTextChange(search: string): void {
    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: { search }
    });
  }

  public onSortChange(sort: Sort) {
    this.fetchPages();
  }

  public onPageChange(page: number): void {
    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: { page }
    });
  }

  public onRowSelect(row: number) {
    this.router.navigate(['edit', this.pages[row].id], {
       relativeTo: this.route
    });
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchPages(): void {
    this.loadingService.continue();

    let query = new PageQuery()
      .include(Page.IMAGE_KEY + '_' + Language.DEFAULT_LANG);

    query.find().then(
      (result) => {
        this.pages = result;
        this.loadingService.complete();
      },
      (error: Parse.Error) => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+page/page-list/page-list.component.ts